/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DATA_ORGANIZATION = 'data-udata-organization';
	var DATA_TERRITORY = 'data-udata-territory';
	var DATA_TERRITORY_ID = 'data-udata-territory-id';
	var DATA_DATASET_ID = 'data-udata-dataset-id';
	
	var DATASETS_LOADED_EVENT_NAME = 'udataset:loaded';
	
	var CHUNK_BY = 12;
	
	var _MAX_SIZE = 50;
	
	function extractURLs(selector) {
	  var parser = document.createElement('a');
	  var script = document.querySelector(selector);
	  var scriptURL = script.dataset.udata || script.src;
	  parser.href = scriptURL;
	  var baseURL = parser.protocol + '//' + parser.host;
	  return [scriptURL, baseURL];
	}
	
	var _extractURLs = extractURLs('script#udata'),
	    _extractURLs2 = _slicedToArray(_extractURLs, 2),
	    scriptURL = _extractURLs2[0],
	    baseURL = _extractURLs2[1];
	
	var apiURL = baseURL + '/api/1/';
	
	function removeDiacritics(str) {
	  var rules = [{ 'base': 'A', 'letters': /[À]/g }, { 'base': 'E', 'letters': /[ÉÊÈ]/g }, { 'base': 'I', 'letters': /[Ï]/g }, { 'base': 'O', 'letters': /[Ô]/g }, { 'base': 'OE', 'letters': /[Œ]/g }, { 'base': 'U', 'letters': /[ÛÙ]/g }, { 'base': 'a', 'letters': /[à]/g }, { 'base': 'e', 'letters': /[éêè]/g }, { 'base': 'i', 'letters': /[ï]/g }, { 'base': 'o', 'letters': /[ô]/g }, { 'base': 'oe', 'letters': /[œ]/g }, { 'base': 'u', 'letters': /[ûù]/g }, { 'base': '', 'letters': /[\])}'’,.\-—–[{(]/g }];
	  rules.forEach(function (rule) {
	    str = str.replace(rule.letters, rule.base);
	  });
	  return str;
	}
	
	function camelCaseData(dataAttributeString) {
	  return dataAttributeString.substr(5).replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	}
	
	function chunk(array, n) {
	  return Array.apply(undefined, _toConsumableArray(Array(Math.ceil(array.length / n)))).map(function (x, i) {
	    return i;
	  }).map(function (x, i) {
	    return array.slice(i * n, i * n + n);
	  });
	}
	
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;
	
	  var timeout = void 0;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      timeout = null;
	      func.apply(undefined, args);
	    }, wait);
	  };
	}
	
	function checkStatus(response) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  } else {
	    var error = new Error(response.statusText);
	    error.response = response;
	    throw error;
	  }
	}
	
	function fetchJSON(url) {
	  return fetch(url).then(checkStatus).then(function (response) {
	    return response.json();
	  });
	}
	
	function zip(arrays) {
	  return arrays[0].map(function (_, i) {
	    return arrays.map(function (array) {
	      return array[i];
	    });
	  });
	}
	
	function buildIntegrationFragment(reference) {
	  var _reference$split = reference.split('-'),
	      _reference$split2 = _toArray(_reference$split),
	      kind = _reference$split2[0],
	      ids = _reference$split2.slice(1);
	
	  var id = ids.join('-');
	  var fragment = document.createElement('div');
	  fragment.classList.add('embed');
	  var help = document.createElement('p');
	  help.classList.add('udata-help');
	  help.innerHTML = '<a href="#">Copy-paste</a> that code into your\n    own HTML and/or <a href="' + baseURL + '/faq/developer/">read the documentation</a>.';
	  fragment.appendChild(help);
	  var textarea = document.createElement('textarea');
	  textarea.innerHTML = '<div data-udata-' + kind + '-id="' + id + '"></div>\n<script src="' + scriptURL + '" id="udata" async defer\nonload="udataScript.loadDatasets()"></script>';
	  fragment.appendChild(textarea);
	  return fragment;
	}
	
	function easeCopyPasting(content) {
	  var textarea = content.querySelector('textarea');
	  textarea.focus();
	  textarea.select();
	  var help = content.querySelector('.udata-help');
	  help.firstChild.addEventListener('click', function (e) {
	    e.preventDefault();
	    textarea.select();
	    document.execCommand('copy');
	  });
	}
	
	function toggleIntegration(event, dataset) {
	  event.preventDefault();
	  var paragraph = dataset.querySelector('.udata-code, .udata-close');
	  var content = dataset.querySelector('.udata-content');
	  var article = dataset.querySelector('.dataset-card');
	  var el = event.target;var _ref = [el.innerHTML, el.dataset.label];
	  el.dataset.label = _ref[0];
	  el.innerHTML = _ref[1];
	
	  paragraph.classList.toggle('udata-close');
	  paragraph.classList.toggle('udata-code');
	  content.classList.toggle('js-hide');
	  if (!paragraph.classList.contains('udata-close')) {
	    content.removeChild(content.querySelector('.embed'));
	  } else {
	    content.appendChild(buildIntegrationFragment(article.id));
	    easeCopyPasting(content);
	  }
	}
	
	function embedDatasetChunk(datasetChunk) {
	  var references = datasetChunk.map(function (el) {
	    if (el.hasAttribute(DATA_TERRITORY_ID)) {
	      return 'territory-' + el.dataset[camelCaseData(DATA_TERRITORY_ID)];
	    } else if (el.hasAttribute(DATA_DATASET_ID)) {
	      return 'dataset-' + el.dataset[camelCaseData(DATA_DATASET_ID)];
	    }
	  });
	  var url = apiURL + 'oembeds/?references=' + references.join(',');
	
	  return fetchJSON(url).then(function (datasetsOEmbededList) {
	    zip([datasetChunk, datasetsOEmbededList]).forEach(function (_ref2) {
	      var _ref3 = _slicedToArray(_ref2, 2),
	          dataset = _ref3[0],
	          response = _ref3[1];
	
	      dataset.innerHTML = response.html;
	      var integrateDataset = dataset.querySelector('.integrate');
	      integrateDataset.addEventListener('click', function (event) {
	        return toggleIntegration(event, dataset);
	      });
	    });
	    return datasetChunk;
	  }).catch(console.error.bind(console));
	}
	
	function embedDatasets(datasets) {
	  var promises = chunk(datasets, CHUNK_BY).map(function (datasetChunk) {
	    return embedDatasetChunk(datasetChunk);
	  });
	  return Promise.all(promises).then(function (chunks) {
	    var _ref4;
	
	    var datasets = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(chunks));
	    var event = void 0;
	    if (typeof window.CustomEvent === 'function') {
	      event = new CustomEvent(DATASETS_LOADED_EVENT_NAME, {
	        detail: { datasets: datasets },
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      event = document.createEvent('CustomEvent');
	      event.initEvent(DATASETS_LOADED_EVENT_NAME, true, true, { datasets: datasets });
	    }
	    window.dispatchEvent(event);
	    return datasets;
	  }).catch(console.error.bind(console));
	}
	
	function filterDatasets(element, event, datasets, initialDatasets) {
	  var searchValue = event.target.value;
	  if (searchValue.length < 3) {
	    element.innerHTML = initialDatasets;
	    return;
	  }
	  var scoredDatasets = datasets.map(function (dataset) {
	    var title = removeDiacritics(dataset.querySelector('.udata-title a').title);
	    return {
	      dataset: dataset,
	      score: title.score(removeDiacritics(searchValue))
	    };
	  });
	
	  var filteredScoredResults = scoredDatasets.filter(function (result) {
	    return result.score > 0.3;
	  });
	  filteredScoredResults.sort(function (a, b) {
	    return a.score < b.score;
	  });
	  if (filteredScoredResults) {
	    element.innerHTML = '';
	    filteredScoredResults.forEach(function (result) {
	      return element.appendChild(result.dataset);
	    });
	  } else {
	    element.innerHTML = initialDatasets;
	  }
	}
	
	function insertSearchInput(event, element) {
	  if (!element.parentNode) return;
	  var datasets = event.detail.datasets;
	  var initialDatasets = element.innerHTML;
	  var searchNode = document.createElement('input');
	  searchNode.placeholder = 'Filter datasets';
	  searchNode.style.display = 'block';
	  searchNode.style.boxSizing = 'border-box';
	  searchNode.style.width = '90%';
	  searchNode.style.maxWidth = '1000px';
	  searchNode.style.margin = '1em';
	  searchNode.style.padding = '.1em';
	  element.parentNode.insertBefore(searchNode, element);
	
	  var debouncedFilterDatasets = debounce(function (event) {
	    return filterDatasets(element, event, datasets, initialDatasets);
	  });
	  searchNode.addEventListener('keydown', debouncedFilterDatasets);
	}
	
	global.udataScript = {
	  loadDatasets: function loadDatasets() {
	    var territories = [].slice.call(document.querySelectorAll('[' + DATA_TERRITORY_ID + ']'));
	    var datasets = [].slice.call(document.querySelectorAll('[' + DATA_DATASET_ID + ']'));
	    return embedDatasets([].concat(_toConsumableArray(territories), _toConsumableArray(datasets)));
	  },
	  loadTerritory: function loadTerritory() {
	    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$withDynamic = _ref5.withDynamic,
	        withDynamic = _ref5$withDynamic === undefined ? true : _ref5$withDynamic,
	        _ref5$withSearch = _ref5.withSearch,
	        withSearch = _ref5$withSearch === undefined ? false : _ref5$withSearch;
	
	    var territoryElement = document.querySelector('[' + DATA_TERRITORY + ']');
	    var territorySlug = territoryElement.dataset[camelCaseData(DATA_TERRITORY)];
	    var territoryId = territorySlug.replace(/-/g, '/');
	    var url = apiURL + 'spatial/zone/' + territoryId + '/datasets?dynamic=' + withDynamic + '&size=' + _MAX_SIZE;
	    return fetchJSON(url).then(function (territoriesAndDatasets) {
	      var territories = territoriesAndDatasets.filter(function (item) {
	        return item.class !== 'Dataset';
	      }).map(function (item) {
	        var fragment = document.createElement('div');
	        fragment.dataset[camelCaseData(DATA_TERRITORY_ID)] = territorySlug + '-' + item.id;
	        territoryElement.appendChild(fragment);
	        return fragment;
	      });
	      var datasets = territoriesAndDatasets.filter(function (item) {
	        return item.class === 'Dataset';
	      }).map(function (item) {
	        var fragment = document.createElement('div');
	        fragment.dataset[camelCaseData(DATA_DATASET_ID)] = item.id;
	        territoryElement.appendChild(fragment);
	        return fragment;
	      });
	      if (withSearch) {
	        window.addEventListener(DATASETS_LOADED_EVENT_NAME, function (event) {
	          return insertSearchInput(event, territoryElement);
	        });
	      }
	      return embedDatasets([].concat(_toConsumableArray(territories), _toConsumableArray(datasets)));
	    }).catch(console.error.bind(console));
	  },
	  loadOrganization: function loadOrganization() {
	    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref6$withSearch = _ref6.withSearch,
	        withSearch = _ref6$withSearch === undefined ? false : _ref6$withSearch;
	
	    var organizationElement = document.querySelector('[' + DATA_ORGANIZATION + ']');
	    var organizationId = organizationElement.dataset[camelCaseData(DATA_ORGANIZATION)];
	    var url = apiURL + 'organizations/' + organizationId + '/datasets/?size=' + _MAX_SIZE;
	    return fetchJSON(url).then(function (res) {
	      var datasets = res.data.map(function (item) {
	        var fragment = document.createElement('div');
	        fragment.dataset[camelCaseData(DATA_DATASET_ID)] = item.id;
	        organizationElement.appendChild(fragment);
	        return fragment;
	      });
	      if (withSearch) {
	        window.addEventListener(DATASETS_LOADED_EVENT_NAME, function (event) {
	          return insertSearchInput(event, organizationElement);
	        });
	      }
	      return embedDatasets(datasets);
	    }).catch(console.error.bind(console));
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	String.prototype.score = function (word, fuzziness) {
	  'use strict';
	
	  if (this === word) {
	    return 1;
	  }
	
	  if (word === "") {
	    return 0;
	  }
	
	  var runningScore = 0,
	      charScore,
	      finalScore,
	      string = this,
	      lString = string.toLowerCase(),
	      strLength = string.length,
	      lWord = word.toLowerCase(),
	      wordLength = word.length,
	      idxOf,
	      startAt = 0,
	      fuzzies = 1,
	      fuzzyFactor,
	      i;
	
	  if (fuzziness) {
	    fuzzyFactor = 1 - fuzziness;
	  }
	
	  if (fuzziness) {
	    for (i = 0; i < wordLength; i += 1) {
	      idxOf = lString.indexOf(lWord[i], startAt);
	
	      if (idxOf === -1) {
	        fuzzies += fuzzyFactor;
	      } else {
	        if (startAt === idxOf) {
	          charScore = 0.7;
	        } else {
	          charScore = 0.1;
	
	          if (string[idxOf - 1] === ' ') {
	            charScore += 0.8;
	          }
	        }
	
	        if (string[idxOf] === word[i]) {
	          charScore += 0.1;
	        }
	
	        runningScore += charScore;
	        startAt = idxOf + 1;
	      }
	    }
	  } else {
	    for (i = 0; i < wordLength; i += 1) {
	      idxOf = lString.indexOf(lWord[i], startAt);
	      if (-1 === idxOf) {
	        return 0;
	      }
	
	      if (startAt === idxOf) {
	        charScore = 0.7;
	      } else {
	        charScore = 0.1;
	        if (string[idxOf - 1] === ' ') {
	          charScore += 0.8;
	        }
	      }
	      if (string[idxOf] === word[i]) {
	        charScore += 0.1;
	      }
	      runningScore += charScore;
	      startAt = idxOf + 1;
	    }
	  }
	
	  finalScore = 0.5 * (runningScore / strLength + runningScore / wordLength) / fuzzies;
	
	  if (lWord[0] === lString[0] && finalScore < 0.85) {
	    finalScore += 0.15;
	  }
	
	  return finalScore;
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	(function (self) {
	  'use strict';
	
	  if (self.fetch) {
	    return;
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && function () {
	      try {
	        new Blob();
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name');
	    }
	    return name.toLowerCase();
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value;
	  }
	
	  function iteratorFor(items) {
	    var iterator = {
	      next: function next() {
	        var value = items.shift();
	        return { done: value === undefined, value: value };
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function () {
	        return iterator;
	      };
	    }
	
	    return iterator;
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function (value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function (name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function (name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var list = this.map[name];
	    if (!list) {
	      list = [];
	      this.map[name] = list;
	    }
	    list.push(value);
	  };
	
	  Headers.prototype['delete'] = function (name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function (name) {
	    var values = this.map[normalizeName(name)];
	    return values ? values[0] : null;
	  };
	
	  Headers.prototype.getAll = function (name) {
	    return this.map[normalizeName(name)] || [];
	  };
	
	  Headers.prototype.has = function (name) {
	    return this.map.hasOwnProperty(normalizeName(name));
	  };
	
	  Headers.prototype.set = function (name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)];
	  };
	
	  Headers.prototype.forEach = function (callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function (name) {
	      this.map[name].forEach(function (value) {
	        callback.call(thisArg, value, name, this);
	      }, this);
	    }, this);
	  };
	
	  Headers.prototype.keys = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.values = function () {
	    var items = [];
	    this.forEach(function (value) {
	      items.push(value);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.entries = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items);
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'));
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function (resolve, reject) {
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	      reader.onerror = function () {
	        reject(reader.error);
	      };
	    });
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    reader.readAsArrayBuffer(blob);
	    return fileReaderReady(reader);
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    reader.readAsText(blob);
	    return fileReaderReady(reader);
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function (body) {
	      this._bodyInit = body;
	      if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (!body) {
	        this._bodyText = '';
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {} else {
	        throw new Error('unsupported BodyInit type');
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob);
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob');
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]));
	        }
	      };
	
	      this.arrayBuffer = function () {
	        return this.blob().then(readBlobAsArrayBuffer);
	      };
	
	      this.text = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob);
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text');
	        } else {
	          return Promise.resolve(this._bodyText);
	        }
	      };
	    } else {
	      this.text = function () {
	        var rejected = consumed(this);
	        return rejected ? rejected : Promise.resolve(this._bodyText);
	      };
	    }
	
	    if (support.formData) {
	      this.formData = function () {
	        return this.text().then(decode);
	      };
	    }
	
	    this.json = function () {
	      return this.text().then(JSON.parse);
	    };
	
	    return this;
	  }
	
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method;
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read');
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = input;
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests');
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function () {
	    return new Request(this);
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function (bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form;
	  }
	
	  function headers(xhr) {
	    var head = new Headers();
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n');
	    pairs.forEach(function (header) {
	      var split = header.trim().split(':');
	      var key = split.shift().trim();
	      var value = split.join(':').trim();
	      head.append(key, value);
	    });
	    return head;
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = options.statusText;
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function () {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    });
	  };
	
	  Response.error = function () {
	    var response = new Response(null, { status: 0, statusText: '' });
	    response.type = 'error';
	    return response;
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function (url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code');
	    }
	
	    return new Response(null, { status: status, headers: { location: url } });
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function (input, init) {
	    return new Promise(function (resolve, reject) {
	      var request;
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input;
	      } else {
	        request = new Request(input, init);
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL;
	        }
	
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL');
	        }
	
	        return;
	      }
	
	      xhr.onload = function () {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        };
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function (value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    });
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : undefined);

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** widgets.js
 **/